// Credit Migration Utility
// Migrates existing localStorage credit data to the new database system

import { authStore } from '../stores/authStore';

export const migrateCreditData = async (): Promise<void> => {
  try {
    // Check if migration has already been done
    const migrationKey = 'credit_migration_completed';
    if (localStorage.getItem(migrationKey) === 'true') {
      return;
    }

    // Get existing localStorage data
    const totalUsed = parseInt(localStorage.getItem('totalCreditsUsed') || '0', 10);
    const hasUnlimited = localStorage.getItem('hasUnlimitedSubscription') === 'true';

    // If user has unlimited subscription, handle that
    if (hasUnlimited) {
      console.log('User has unlimited subscription - needs manual migration');
      localStorage.setItem(migrationKey, 'true');
      return;
    }

    // If no credits were used, no migration needed
    if (totalUsed === 0) {
      localStorage.setItem(migrationKey, 'true');
      return;
    }

    // Clean up old localStorage keys
    localStorage.removeItem('totalCreditsUsed');
    localStorage.removeItem('anonymousCreditsUsed');
    localStorage.removeItem('authenticatedCreditsUsed');
    localStorage.removeItem('aiSearchCount');

    // Mark migration as complete
    localStorage.setItem(migrationKey, 'true');

    console.log('Credit migration completed successfully');
  } catch (error) {
    console.error('Credit migration failed:', error);
    // Don't throw error to prevent app from breaking
  }
};

// Auto-run migration on app startup
export const initializeCreditMigration = async (): Promise<void> => {
  // Wait a bit for auth to initialize
  setTimeout(migrateCreditData, 1000);
};